import {
    HOMEPAGE_SETTINGS_UPLOAD_START,
    HOMEPAGE_SETTINGS_UPLOAD_ERROR,
    HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader'
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateHomePageSafetyMutation as mutation } from '../../lib/graphql';

export const updateHomepageSettingsSafety = (values) => {

    return async (dispatch, getState, { client }) => {

        try {
            dispatch(setLoaderStart('SafetySettingsForm'));
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_START
            })

            let title, description;
            title = values?.safetyGridTitle1.length && values?.safetyGridTitle1[0]?.value;
            description = values?.safetyGridTitle1.length && values?.safetyGridTitle1[0]?.description;

            const { data } = await client.mutate({
                mutation,
                variables: {
                    safetyGridImage1: values?.safetyGridImage1,
                    safetyGridImage2: values?.safetyGridImage2,
                    safetyGridImage3: values?.safetyGridImage3,
                    safetyGridTitle1: title,
                    safetyGridContent1: description,
                    safetyGridLink1: values?.safetyGridLink1,
                    safetyGridLink2: values?.safetyGridLink2,
                    safetyGridImage4: values?.safetyGridImage4,
                    dynamicAppSettings: values?.safetyGridTitle1
                }
            })

            if (data?.updateHomePageSafety?.status == 200) {

                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_SUCCESS
                })
                showToaster({ messageId: 'updateCitySuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
                })
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateHomePageSafety?.errorMessage }, toasterType: 'error' });
            }
            dispatch(setLoaderComplete('SafetySettingsForm'));
        } catch (err) {
            dispatch(setLoaderComplete('SafetySettingsForm'));
            dispatch({
                type: HOMEPAGE_SETTINGS_UPLOAD_ERROR
            })
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
        }
    }
}